import React, { useId } from 'react'
import PropTypes from 'prop-types'

const CloudKeyIcon = React.forwardRef(function CloudKeyIcon(props, ref) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path d="M17 12H12.82C12.41 10.84 11.31 10 10 10C8.35 10 7 11.35 7 13C7 14.65 8.35 16 10 16C11.3 16 12.4 15.16 12.82 14H15V15C15 15.55 15.45 16 16 16C16.55 16 17 15.55 17 15V14C17.55 14 18 13.55 18 13C18 12.45 17.55 12 17 12ZM10 14C9.45 14 9 13.55 9 13C9 12.45 9.45 12 10 12C10.55 12 11 12.45 11 13C11 13.55 10.55 14 10 14Z"></path>
      <path d="M19.96 10.22C19.57 6.17 16.15 3 12 3C7.85 3 4.46 6.15 4.04 10.22C1.69 10.86 0 13 0 15.5C0 18.53 2.47 21 5.5 21H18.5C21.53 21 24 18.53 24 15.5C24 13 22.32 10.86 19.96 10.22ZM18.5 19H5.5C3.57 19 2 17.43 2 15.5C2 13.73 3.34 12.24 5.11 12.04C5.62 11.98 6 11.51 6 11C6 7.69 8.69 5 12 5C15.31 5 18 7.69 18 10.95C18 10.97 18 11.02 18 11.05C18 11.56 18.38 11.99 18.89 12.04C20.66 12.24 22 13.72 22 15.5C22 17.43 20.43 19 18.5 19Z"></path>
    </svg>
  )
})

CloudKeyIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

CloudKeyIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default CloudKeyIcon
